/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 -k -T -j RAFALE_V4.glb 
Files: RAFALE_V4.glb [151.21MB] > /home/salem/blownupmodel/20250826_rafale_02/RAFALE_V4-transformed.glb [9.07MB] (94%)
*/

import React, { useEffect, useRef, useCallback, forwardRef } from 'react'
import { useFrame, useGraph } from '@react-three/fiber'
import { SkeletonUtils } from 'three-stdlib'
import { MeshStandardMaterial } from "three";

import { useGLTF } from '@react-three/drei'
import * as THREE from 'three';

const originalMaterials = new Map();

const redMaterial = new MeshStandardMaterial({
  color: 0xFF0000,
  metalness: 0.5,
  roughness: 1,
  name: "red",
  // transparent: true,
  // opacity: 0.9,
});

const orangeMaterial = new MeshStandardMaterial({
  color: 0xfb8500,
  metalness: 0.5,
  roughness: 1,
  name: "orange"
});

const yellowMaterial = new MeshStandardMaterial({
  color: 0xff7b00,
  metalness: 0.5,
  roughness: 5,
  name: "yellow"
});

const Rafale = forwardRef(({ vehicle, isTransparent = false, isCrashed = false, onLoad, ...props }, ref) => {
  const { scene } = useGLTF('/3d/model-rafale.glb');
  const clone = React.useMemo(() => SkeletonUtils.clone(scene), [scene])
  const { nodes, materials } = useGraph(clone)

  const ORIGINAL_OPACITY = 0.3
  const rotationSpeed = 0.02;
  // Rotation sur l’axe Y (et non Z), mais on garde les noms pour ne pas tout casser
  const minRotationZLeft = 0; // porte fermée (référence)
  const maxRotationZLeft = Math.PI / 3; // ≈ 60° vers l'extérieur

  const maxRotationZRight = Math.PI / 3; // porte fermée
  const minRotationZRight = 0; // ≈ -60° vers l'extérieur

  const minTrunkRotation = 0;
  const maxTrunkRotation = Math.PI / 3;
  const blinkInterval = 500;

  const DoorFrontLeftOpenRef = useRef();
  const DoorFrontRightOpenRef = useRef();
  const DoorRearLeftOpenRef = useRef();
  const DoorRearRightOpenRef = useRef();

  const TireFrontLeftRef = useRef();
  const TireFrontRightRef = useRef();
  const TireRearLeftRef = useRef();
  const TireRearRightRef = useRef();

  const BrakeWornFrontLeftRef = useRef();
  const BrakeWornFrontRightRef = useRef();
  const BrakeWornRearLeftRef = useRef();
  const BrakeWornRearRightRef = useRef();


  const HazardLightFrontLeftIsSignalingRef = useRef();
  const HazardLightFrontRightIsSignalingRef = useRef();
  const HazardLightRearLeftIsSignalingRef = useRef();
  const HazardLightRearRightIsSignalingRef = useRef();

  const TrunkOpenRef = useRef();

  const EngineRef = useRef();


  useEffect(() => {

    clone.current?.traverse((child) => {
      if (!child.isMesh) return;
      // Ensure each mesh has its own material instance before mutation
      if (child.material && !child.material.isCloned) {
        child.material = child.material.clone();
        child.material.isCloned = true;
      }
      const redCrashedMeshes = ["Rafale_018002"];
      if (isCrashed && redCrashedMeshes.includes(child.name)) {
        child.material = redMaterial;
      }
      if (isTransparent && child.material.name !== "orange") {
        child.material.transparent = true;
        child.material.opacity = ORIGINAL_OPACITY;
        // console.log("turning" + child.name +"transparent")
      }
      child.material.side = THREE.DoubleSide;
    });

    onLoad?.();
  }, [clone, isTransparent, isCrashed, onLoad]);



  const handleDoorsAnimation = useCallback(() => {
    const doors = [
      {
        ref: DoorFrontLeftOpenRef,
        isOpen: vehicle?.Vehicle?.Cabin?.Door?.Row1?.DriverSide?.IsOpen,
        axis: "y",
        min: minRotationZLeft,
        max: maxRotationZLeft,
        direction: -1, // vers l'extérieur = +Y
      },
      {
        ref: DoorRearLeftOpenRef,
        isOpen: vehicle?.Vehicle?.Cabin?.Door?.Row2?.DriverSide?.IsOpen,
        axis: "y",
        min: minRotationZLeft,
        max: maxRotationZLeft,
        direction: -1,
      },
      {
        ref: DoorFrontRightOpenRef,
        isOpen: vehicle?.Vehicle?.Cabin?.Door?.Row1?.PassengerSide?.IsOpen,
        axis: "y",
        min: minRotationZRight,
        max: maxRotationZRight,
        direction: 1, // vers l'extérieur = -Z
      },
      {
        ref: DoorRearRightOpenRef,
        isOpen: vehicle?.Vehicle?.Cabin?.Door?.Row2?.PassengerSide?.IsOpen,
        axis: "y",
        min: minRotationZRight,
        max: maxRotationZRight,
        direction: 1,
      }
    ];

    doors.forEach(({ ref, isOpen, axis, min, max, direction }) => {
      if (!ref.current) return;
      console.log("ref", ref.current)
      const currentRotation = ref.current.rotation[axis];

      if (isOpen && Math.abs(currentRotation) < max - 0.01) {
        ref.current.rotation[axis] += rotationSpeed * direction;
      } else if (!isOpen && Math.abs(currentRotation) > min + 0.01) {
        ref.current.rotation[axis] -= rotationSpeed * direction;
      }
    });
  }, [
    maxRotationZLeft,
    maxRotationZRight,
    vehicle?.Vehicle?.Cabin?.Door?.Row1?.DriverSide?.IsOpen,
    vehicle?.Vehicle?.Cabin?.Door?.Row2?.DriverSide?.IsOpen,
    vehicle?.Vehicle?.Cabin?.Door?.Row1?.PassengerSide?.IsOpen,
    vehicle?.Vehicle?.Cabin?.Door?.Row2?.PassengerSide?.IsOpen,
  ]);


  const handleTrunkAnimation = useCallback(() => {
    if (TrunkOpenRef.current) {
      const currentTrunkRotation = TrunkOpenRef.current.rotation.z;
      const isTrunkOpen = vehicle?.Vehicle?.Body?.Trunk?.Rear?.IsOpen;

      if (isTrunkOpen && currentTrunkRotation < maxTrunkRotation) {
        TrunkOpenRef.current.rotation.z += rotationSpeed;
      }
      if (!isTrunkOpen && currentTrunkRotation > minTrunkRotation) {
        TrunkOpenRef.current.rotation.z -= rotationSpeed;
      }

    }
  }, [
    maxTrunkRotation,
    vehicle?.Vehicle?.Body?.Trunk?.Rear?.IsOpen])


  // TODO : Add wheel rotation based on speed
  // const handleSpeedAnimation = useCallback((deltaTime) => {
  //   const speed = vehicle?.Vehicle?.Speed;
  //   const wheelRadius = 19;
  //   const angularSpeed = speed / wheelRadius;

  //   const wheels = [
  //     { ref: TireFrontLeftRef, isRear: false },
  //     { ref: TireFrontRightRef, isRear: false },
  //     { ref: TireRearLeftRef, isRear: true },
  //     { ref: TireRearRightRef, isRear: true },
  //   ];

  //   wheels.forEach(({ ref, isRear }) => {
  //     const wheel = ref.current;
  //     if (wheel) {
  //       if (isRear) {
  //         wheel.rotation.x -= angularSpeed * deltaTime;
  //       } else {
  //         wheel.rotation.x += angularSpeed * deltaTime;
  //       }
  //     }
  //   });
  // }, [vehicle?.Vehicle?.Speed]);


  const handleTireLowPressure = useCallback(() => {
    const tires = [
      {
        ref: TireFrontLeftRef,
        pressureLow: vehicle?.Vehicle?.Chassis?.Axle?.Row1?.Wheel?.Left?.Tire?.IsPressureLow
      },
      {
        ref: TireFrontRightRef,
        pressureLow: vehicle?.Vehicle?.Chassis?.Axle?.Row1?.Wheel?.Right?.Tire?.IsPressureLow
      },
      {
        ref: TireRearLeftRef,
        pressureLow: vehicle?.Vehicle?.Chassis?.Axle?.Row2?.Wheel?.Left?.Tire?.IsPressureLow
      },
      {
        ref: TireRearRightRef,
        pressureLow: vehicle?.Vehicle?.Chassis?.Axle?.Row2?.Wheel?.Right?.Tire?.IsPressureLow
      }
    ];
    tires.forEach(({ ref, pressureLow }) => {
      if (!ref.current) return;

      const name = ref.current.name;
      const currentMaterial = ref.current.material;

      if (pressureLow) {
        if (!originalMaterials.has(name)) {
          originalMaterials.set(name, currentMaterial);
        }
        ref.current.material = redMaterial;
      } else if (originalMaterials.has(name)) {
        ref.current.material = originalMaterials.get(name);
      }
    });
  }, [
    vehicle?.Vehicle?.Chassis?.Axle?.Row1?.Wheel?.Left?.Tire?.IsPressureLow,
    vehicle?.Vehicle?.Chassis?.Axle?.Row1?.Wheel?.Right?.Tire?.IsPressureLow,
    vehicle?.Vehicle?.Chassis?.Axle?.Row2?.Wheel?.Left?.Tire?.IsPressureLow,
    vehicle?.Vehicle?.Chassis?.Axle?.Row2?.Wheel?.Right?.Tire?.IsPressureLow,
  ]);



  const handleBrakeWorn = useCallback(() => {
    const brakes = [
      {
        ref: BrakeWornFrontLeftRef,
        tire: TireFrontLeftRef,
        isWorn: vehicle?.Vehicle?.Chassis?.Axle?.Row1?.Wheel?.Left?.Brake?.IsBrakesWorn
      },
      {
        ref: BrakeWornFrontRightRef,
        tire: TireFrontRightRef,
        isWorn: vehicle?.Vehicle?.Chassis?.Axle?.Row1?.Wheel?.Right?.Brake?.IsBrakesWorn
      },
      {
        ref: BrakeWornRearLeftRef,
        tire: TireRearLeftRef,
        isWorn: vehicle?.Vehicle?.Chassis?.Axle?.Row2?.Wheel?.Left?.Brake?.IsBrakesWorn
      },
      {
        ref: BrakeWornRearRightRef,
        tire: TireRearRightRef,
        isWorn: vehicle?.Vehicle?.Chassis?.Axle?.Row2?.Wheel?.Right?.Brake?.IsBrakesWorn
      }
    ];
    brakes.forEach(({ ref, isWorn }) => {
      if (!ref.current) return;

      const name = ref.current.name;
      const currentMaterial = ref.current.material;

      if (isWorn) {
        if (!originalMaterials.has(name)) {
          originalMaterials.set(name, currentMaterial);
        }

        if (
          vehicle?.Vehicle?.Chassis?.Axle?.Row1?.Wheel?.Left?.Brake?.IsBrakesWorn &&
          vehicle?.Vehicle?.Chassis?.Axle?.Row1?.Wheel?.Right?.Brake?.IsBrakesWorn &&
          vehicle?.Vehicle?.Chassis?.Axle?.Row2?.Wheel?.Left?.Brake?.IsBrakesWorn &&
          vehicle?.Vehicle?.Chassis?.Axle?.Row2?.Wheel?.Right?.Brake?.IsBrakesWorn
        ) {
          ref.current.material = redMaterial;
        } else {
          ref.current.material = orangeMaterial;
        }

      } else if (originalMaterials.has(name)) {
        ref.current.material = originalMaterials.get(name);
      }
    });
  }, [
    vehicle?.Vehicle?.Chassis?.Axle?.Row1?.Wheel?.Left?.Brake?.IsBrakesWorn,
    vehicle?.Vehicle?.Chassis?.Axle?.Row1?.Wheel?.Right?.Brake?.IsBrakesWorn,
    vehicle?.Vehicle?.Chassis?.Axle?.Row2?.Wheel?.Left?.Brake?.IsBrakesWorn,
    vehicle?.Vehicle?.Chassis?.Axle?.Row2?.Wheel?.Right?.Brake?.IsBrakesWorn,
  ]);

  const handleEngine = useCallback(() => {
    const engineOilTemperature = vehicle?.Vehicle.Powertrain.CombustionEngine.EOT;

    if (EngineRef.current) {
      if (!originalMaterials.has(EngineRef.current.name)) {
        const firstChildMaterial = EngineRef.current.children[0]?.material;
        if (firstChildMaterial) {
          originalMaterials.set(EngineRef.current.name, firstChildMaterial);
        }
      }

      if (engineOilTemperature >= 120) {

        EngineRef.current.children.forEach(child => {
          if (child.material) {
            child.material = redMaterial;
          }
        });

      } else {

        const originalMaterial = originalMaterials.get(EngineRef.current.name);
        EngineRef.current.children.forEach(child => {
          if (child.material) {
            child.material = originalMaterial;
          }
        });
      }
    }
  }, [vehicle?.Vehicle?.Powertrain?.CombustionEngine?.EOT]);


  const handleHazardLights = useCallback(() => {
    const hazardLightsIsSignaling = vehicle?.Vehicle?.Body?.Lights?.Hazard?.IsSignaling;
    if (HazardLightFrontLeftIsSignalingRef.current) {
      const hazardLights = [
        HazardLightFrontLeftIsSignalingRef.current,
        HazardLightFrontRightIsSignalingRef.current,
        HazardLightRearLeftIsSignalingRef.current,
        HazardLightRearRightIsSignalingRef.current
      ];

      if (!originalMaterials.has(hazardLights[0].name)) {
        originalMaterials.set(hazardLights[0].name, hazardLights[0].material);
      }

      if (hazardLightsIsSignaling) {
        if (hazardLights[0].material === originalMaterials.get(hazardLights[0].name)) {
          hazardLights.forEach(light => {
            if (light) light.material = yellowMaterial;
          });
        }
        else {
          hazardLights.forEach(light => {
            if (light) light.material = originalMaterials.get(hazardLights[0].name);
          });
        }

      } else {
        hazardLights.forEach(light => {
          if (light) light.material = originalMaterials.get(hazardLights[0].name);
        });
      }
    }
  }, [vehicle?.Vehicle?.Body?.Lights?.Hazard?.IsSignaling]);

  useEffect(() => {
    const interval = setInterval(handleHazardLights, blinkInterval);

    return () => {
      clearInterval(interval);
    }
  }, [handleHazardLights]);

  useFrame(() => {
    handleDoorsAnimation();
    handleTrunkAnimation();
    // handleSpeedAnimation(0.1);
    handleTireLowPressure();
    handleBrakeWorn();
    handleEngine();

  });



  return (

    <group ref={ref} {...props} position={[0, -0.7, 0]} rotation={[0, Math.PI / 2, 0]} dispose={null}>
      <group ref={clone} >
        <mesh name="Front_Left_Break_Caliper" geometry={nodes.Front_Left_Break_Caliper.geometry} material={materials.wire_115115115} ref={BrakeWornFrontLeftRef} />
        <mesh name="Rafale_006" geometry={nodes.Rafale_006.geometry} material={materials.wire_115115115} />
        <mesh name="Tailgate" geometry={nodes.Tailgate.geometry} material={materials.wire_115115115} position={[1.417, 1.575, 0.001]} ref={TrunkOpenRef} />
        <mesh name="Front_Right_Wheel" geometry={nodes.Front_Right_Wheel.geometry} material={materials.wire_115115115} ref={TireFrontRightRef} />
        <mesh name="Rear_Right_Wheel" geometry={nodes.Rear_Right_Wheel.geometry} material={materials.wire_115115115} ref={TireRearRightRef} />
        <mesh name="Rear_Right_Door" geometry={nodes.Rear_Right_Door.geometry} material={materials.wire_115115115} position={[0.129, 0.96, -0.959]} ref={DoorRearRightOpenRef} />
        <mesh name="Rafale_043" geometry={nodes.Rafale_043.geometry} material={materials.wire_115115115} />
        <mesh name="Rafale_045" geometry={nodes.Rafale_045.geometry} material={materials.wire_115115115} />
        <mesh name="Rafale_051" geometry={nodes.Rafale_051.geometry} material={materials.wire_115115115} />
        <mesh name="Rafale_080" geometry={nodes.Rafale_080.geometry} material={materials.wire_115115115} />
        <mesh name="Rafale_089" geometry={nodes.Rafale_089.geometry} material={materials.wire_115115115} />
        <mesh name="Front_Lights_Right_Signal" geometry={nodes.Front_Lights_Right_Signal.geometry} material={materials.wire_115115115} ref={HazardLightFrontRightIsSignalingRef} />
        <mesh name="Rafale_104" geometry={nodes.Rafale_104.geometry} material={materials.wire_115115115} />
        <mesh name="Front_Right_Break_Caliper" geometry={nodes.Front_Right_Break_Caliper.geometry} material={materials.wire_115115115} ref={BrakeWornFrontRightRef} />
        <mesh name="Rafale_123" geometry={nodes.Rafale_123.geometry} material={materials.wire_115115115} />
        <mesh name="Rear_Right_Break_Caliper" geometry={nodes.Rear_Right_Break_Caliper.geometry} material={materials.wire_115115115} ref={BrakeWornRearRightRef} />
        <mesh name="Rafale_129" geometry={nodes.Rafale_129.geometry} material={materials.wire_115115115} />
        <mesh name="Rafale_131" geometry={nodes.Rafale_131.geometry} material={materials.wire_115115115} />
        <mesh name="Rear_Left_Break_Caliper" geometry={nodes.Rear_Left_Break_Caliper.geometry} material={materials.wire_115115115} ref={BrakeWornRearLeftRef} />
        <mesh name="Front_Left_Wheel" geometry={nodes.Front_Left_Wheel.geometry} material={materials.wire_115115115} ref={TireFrontLeftRef} />
        <mesh name="Rear_Left_Wheel" geometry={nodes.Rear_Left_Wheel.geometry} material={materials.wire_115115115} ref={TireRearLeftRef} />
        <mesh name="Front_Right_Door" geometry={nodes.Front_Right_Door.geometry} material={materials.wire_115115115} position={[-1.083, 1.003, -0.946]} ref={DoorFrontRightOpenRef} />
        <mesh name="Front_Left_Door" geometry={nodes.Front_Left_Door.geometry} material={materials.wire_115115115} position={[-1.083, 1.003, 0.946]} ref={DoorFrontLeftOpenRef} />
        <mesh name="Rear_Left_Door" geometry={nodes.Rear_Left_Door.geometry} material={materials.wire_115115115} position={[0.129, 0.96, 0.959]} ref={DoorRearLeftOpenRef} />
        <mesh name="Rafale_012004" geometry={nodes.Rafale_012004.geometry} material={materials.wire_115115115} />
        <mesh name="Rafale_018002" geometry={nodes.Rafale_018002.geometry} material={materials.wire_115115115} />
        <mesh name="Rafale_018003" geometry={nodes.Rafale_018003.geometry} material={materials.wire_115115115} />
        <mesh name="Rafale_094001" geometry={nodes.Rafale_094001.geometry} material={materials.wire_115115115} />
        <mesh name="Rafale_017001" geometry={nodes.Rafale_017001.geometry} material={materials.wire_115115115} />
        <mesh name="Front_Lights_Left_Signal" geometry={nodes.Front_Lights_Left_Signal.geometry} material={materials.wire_115115115} ref={HazardLightFrontLeftIsSignalingRef} />
        <mesh name="Rafale_012001" geometry={nodes.Rafale_012001.geometry} material={materials.wire_115115115} />
        <group ref={EngineRef}>
          <mesh name="Front_Electric_Engine" geometry={nodes.Front_Electric_Engine.geometry} material={nodes.Front_Electric_Engine.material} />
          <mesh name="Rear_Electric_Engine" geometry={nodes.Rear_Electric_Engine.geometry} material={nodes.Rear_Electric_Engine.material} />
        </group>
        <mesh name="Battery" geometry={nodes.Battery.geometry} material={nodes.Battery.material} />
        <mesh name="Rafale_060002" geometry={nodes.Rafale_060002.geometry} material={materials.wire_115115115} />
        <mesh name="Rafale_060001" geometry={nodes.Rafale_060001.geometry} material={materials.wire_115115115} />
        <mesh name="Rear_Lights_Right_Signal" geometry={nodes.Rear_Lights_Right_Signal.geometry} material={materials.wire_115115115} ref={HazardLightRearRightIsSignalingRef} />
        <mesh name="Rear_Lights_Left_Signal" geometry={nodes.Rear_Lights_Left_Signal.geometry} material={materials.wire_115115115} ref={HazardLightRearLeftIsSignalingRef} />
        <mesh name="Rafale_012002" geometry={nodes.Rafale_012002.geometry} material={materials.wire_115115115} />
      </group>

    </group>

  )
})

export { Rafale };


useGLTF.preload('/3d/model-rafale.glb')




export const rafaleOccupantPositions = {
  Row1: {
    DriverSide: [0.4, -0.25, 1.1],
    PassengerSide: [-0.4, -0.25, 1.1],
  },
  Row2: {
    DriverSide: [0.5, -0.25, -0.1],
    PassengerSide: [-0.5, -0.25, -0.1],
    Middle: [0, -0.25, -0.1],
  },
};



export const rafaleCameraPositions = {
  initialPosition: [0, 12, 0.01],
  frontPosition: [0, 1.3, 7.5]
}